// extracted by mini-css-extract-plugin
export default {"navbar":"RightSideBar_navbar__ogyWj","heading":"RightSideBar_heading__SgqIa","searchBtn":"RightSideBar_searchBtn__oyEx9"};